import axios from 'axios'
import Qs from 'qs';
export const GET_GAS_LOG_REQUEST = 'GET_GAS_LOG_REQUEST'
export const GET_GAS_LOG_DELETE = 'GET_GAS_LOG_DELETE'
export const GET_GAS_LOG_SUCCESS = 'GET_GAS_LOG_SUCCESS'
export const GET_GAS_LOG_FAILURE = 'GET_GAS_LOG_FAILURE'

export const getGasLogRequest = () => {
  return {
    type: GET_GAS_LOG_REQUEST
  }
}

export const getGasLogDelete = () => {
  return {
    type: GET_GAS_LOG_DELETE
  }
}

export const getGasLogSuccess = (data) => {
  return {
    type: GET_GAS_LOG_SUCCESS,
    gas: data
  }
}

export const getGasLogFailure = (error) => {
  return {
    type: GET_GAS_LOG_FAILURE,
    error
  }
}

export const getGasLog = (modules) => {
  const params = {
    modules: modules.map(d => {return d.moduleIdx})
  }
  
  let myAxios = axios.create({
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
  })

  return (dispatch) => {
    dispatch(getGasLogRequest());
    
    return myAxios.get('/api/gas/status', {params})
      .then(response => {
        dispatch(getGasLogSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(getGasLogFailure(error));
      });
  }
}

export const gasLog = (state = {status: 'WAITING'}, action) => {
  switch (action.type) {
    case 'GET_GAS_LOG_REQUEST':
      return {...state, status: 'WAITING'}
    case 'GET_GAS_LOG_DELETE':
      return {}
    case 'GET_GAS_LOG_SUCCESS':
      return {...state, gas: action.gas, status: 'SUCCESS'}
    case 'GET_GAS_LOG_FAILURE':
      console.log(state);
      return state
    default:
      return state
  }
}